import Add from '@mui/icons-material/Add'
import { Button, Chip, Grid } from '@mui/material'
import { getValueFromDotOperatorString } from 'src/shared/utils/objectPath'
import SingleExpandAccordionWrapper from 'src/consumer/components/common/accordion/SingleExpandAccordionWrapper'
import ClinicBrandOnboardingProspectInput from './ClinicBrandOnboardingProspectInput'

export default function StaffOnboardingCards({
  clinicBrand,
  staffAccordionState,
  setStaffAccordionState,
  staffTypeValue,
  handleChangeProspects,
  handleRemoveProspect,
  handleAddProspect,
  checkIfAProspectContactIsValid,
  hideWorkForceInfo = false,
}) {
  const workForceItemsList = staffTypeValue?.workForceId
    ? getValueFromDotOperatorString(clinicBrand || {}, staffTypeValue?.workForceId || '')
    : []
  const prospectItemsList = getValueFromDotOperatorString(clinicBrand, staffTypeValue?.id) || []

  const validProspectItemsList = [
    ...prospectItemsList
      ?.filter((contact, idx, currArr) => {
        //make uid in the list unique.
        const uid = contact?.uid
        const existingContact = currArr?.find((contact) => contact?.uid === uid)
        return !existingContact
      })
      ?.filter((prospectContact) => {
        return checkIfAProspectContactIsValid(prospectContact)
        // return (
        //   (!!prospectEmail?.email && isValidEmail(prospectEmail?.email)) ||
        //   (!!prospectEmail?.mobile && isValidPhoneNumber(`+${prospectEmail?.mobile}`))
        // )
      }),
  ]

  const staffCount = validProspectItemsList?.length || 0 + workForceItemsList?.length || 0

  console.log({ staffTypeValue, clinicBrand, workForceItemsList, prospectItemsList })

  return (
    <>
      <Grid item xs={12} sx={{ mb: 2, mt: 2 }}>
        <SingleExpandAccordionWrapper
          accordionProps={{ elevation: 0, sx: { border: '1px solid rgb(117, 138, 174)' } }}
          accordionSummaryHeading={
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <span>{staffTypeValue?.multiTitle}</span>
              {staffCount > 0 ? (
                <Chip
                  size="small"
                  label={`${workForceItemsList?.length || 0} ${
                    validProspectItemsList?.length
                      ? `(+ ${validProspectItemsList.length} yet to be approved)`
                      : ''
                  }`}
                />
              ) : (
                <Chip size="small" label="None" />
              )}
            </div>
          }
          expandedItemIdentifier={staffTypeValue?.id}
          isExpanded={staffAccordionState === staffTypeValue?.id}
          expandOnChange={() => setStaffAccordionState(staffTypeValue?.id)}
        >
          {!hideWorkForceInfo && (
            <>
              <strong>Approved {staffTypeValue?.multiTitle}</strong>

              {Array.isArray(workForceItemsList) && workForceItemsList?.length > 0 && (
                <>
                  <div style={{ marginTop: '16px' }}>
                    {workForceItemsList?.map((item, index) => (
                      <div className="mt-1" key={index}>
                        {index + 1}. {item?.title} ({item?.email || item?.mobile})
                      </div>
                    ))}
                  </div>
                </>
              )}
              <hr></hr>
            </>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '17px' }}>
            <strong>Yet to be approved {staffTypeValue?.multiTitle}</strong>
            {(getValueFromDotOperatorString(clinicBrand, staffTypeValue?.id) || [])?.map(
              (item, idx) => (
                <ClinicBrandOnboardingProspectInput
                  key={idx}
                  idx={idx}
                  prospectTypeValue={staffTypeValue}
                  handleChangeProspects={handleChangeProspects}
                  handleRemoveProspect={handleRemoveProspect}
                  item={item}
                  parentObject={clinicBrand}
                />
              ),
            )}
            <Button
              sx={{ width: '100%' }}
              variant="outlined"
              endIcon={<Add />}
              onClick={() => handleAddProspect(staffTypeValue)}
            >
              {(getValueFromDotOperatorString(clinicBrand, staffTypeValue?.id) || [])?.length > 0
                ? 'Add Another'
                : 'Add One'}
            </Button>
          </div>
        </SingleExpandAccordionWrapper>
      </Grid>
    </>
  )
}
